<template>
  <div>
    <SeoHero />
    <Seo1 />
    <Seo2 />
    <Seo3 />
    <Seo4 />
    <Seo5 />
    <Seo6 />
    <Seo7 />
    <Seo8 />
    <Seo9 />
  </div>
</template>

<script>
import SeoHero from '@/components/Seo/SeoHero.vue'
import Seo1 from '@/components/Seo/Seo1.vue'
import Seo2 from '@/components/Seo/Seo2.vue'
import Seo3 from '@/components/Seo/Seo3.vue'
import Seo4 from '@/components/Seo/Seo4.vue'
import Seo5 from '@/components/Seo/Seo5.vue'
import Seo6 from '@/components/Seo/Seo6.vue'
import Seo7 from '@/components/Seo/Seo7.vue'
import Seo8 from '@/components/Seo/Seo8.vue'
import Seo9 from '@/components/Seo/Seo9.vue'

export default {
  name: 'Preview',
  components: {
    SeoHero,
    Seo1,
    Seo2,
    Seo3,
    Seo4,
    Seo5,
    Seo6,
    Seo7,
    Seo8,
    Seo9,
  },
}
</script>
